import React from 'react';

import './InputRadioGroupField.scss';

const InputRadioGroupField = props => {
  const { inputId, value, options, onChange, editMode } = props;

  const selectedOption = options.filter(option => option.value === value);
  const selectedOptionLabel = selectedOption.length ? selectedOption[0].label : '';

  return (
    <div className="parkchirp--input-radio-group-field">
      {editMode ?
        options.map(option => {
          const optionId = inputId + '__' + option.value.toString().toLowerCase();

          return (
            <span
              key={option.value}
              className="parkchirp--input-radio-option">
              <input
                type="radio"
                id={optionId}
                name={inputId}
                value={option.value}
                checked={option.value === value}
                onChange={event => onChange(event.target.value)}
              />
              <label htmlFor={optionId}>{option.label}</label>
            </span>
          );
        })
        :
        <span>{selectedOptionLabel}</span>
      }
    </div>
  );
}

export default InputRadioGroupField;
